<template>
	<div class="select-unit-container">
		<!-- Header -->
		<div class="page-header">
			<h1 class="page-title">{{ $t("selectUnit.txtTitle") }}</h1>
			<p class="page-subtitle" v-if="transportUnits.length > 0">
				{{ transportUnits.length }} {{ $t("selectUnit.txtAvailable") || 'disponibles' }}
			</p>
		</div>

		<!-- Units List -->
		<div class="units-list" v-if="transportUnits.length > 0">
			<div
				v-for="(item, index) in transportUnits"
				:key="item.name"
				class="unit-card"
				:class="{ 'unit-selected': selected === index }"
				@click="selected = index"
			>
				<div class="unit-icon">
					<v-icon size="24" :color="selected === index ? '#6200ea' : '#999'">
						mdi-car
					</v-icon>
				</div>
				<div class="unit-info">
					<span class="unit-name">{{ item.name }}</span>
					<span class="unit-model">{{ item.unitBrand }} {{ item.unitModel }}</span>
					<span class="unit-plate">{{ item.plateNumber }}</span>
				</div>
				<div class="unit-check">
					<v-icon v-if="selected === index" color="#6200ea" size="22">
						mdi-check-circle
					</v-icon>
					<v-icon v-else color="#ddd" size="22">
						mdi-circle-outline
					</v-icon>
				</div>
			</div>
		</div>

		<!-- Empty State -->
		<div v-else class="empty-state">
			<v-icon size="48" color="#ccc">mdi-car-off</v-icon>
			<p>{{ $t("selectUnit.txtEmpty") || 'No hay unidades disponibles' }}</p>
		</div>

		<!-- Save Button -->
		<div class="action-container" v-if="transportUnits.length > 0">
			<button
				class="save-btn"
				:class="{ 'btn-disabled': selected === null }"
				:disabled="selected === null"
				@click.prevent="saveChange"
			>
				{{ $t("profile.btnSave") }}
			</button>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
	name: "SelectUnit",
	data: () => ({
		selected: null,
		transportUnits: [],
	}),
	computed: {
		...mapState("auth", {
			user: (state) => state.user,
		}),
	},
	methods: {
		...mapActions("ui", {
			disabledNavigation: "disabledNavigation",
			activeBackBtn: "activeBackBtn",
			showProgress: "showProgress",
			hideProgress: "hideProgress",
		}),
		...mapMutations("auth", {
			setUnitTransport: "setUnitTransport",
		}),
		saveChange() {
			this.showProgress();
			const transportUnit = this.transportUnits[this.selected]; //
			this.$axios
				.post(`/transport-units/${transportUnit.id}/assign-driver`)
				.then((res) => {
					// Ocultar notificacion
					this.hideProgress();

					// Guardar el transporte
					this.setUnitTransport(res.data);

					// notificar
					this.$store.commit(
						"ui/openSnackbar",
						this.$t("selectUnit.txtNotification")
					);

					// Redirigir al lugar correcto
					this.$router.push({ name: "Home" });
				});
		},
	},
	mounted() {
		this.showProgress();
		this.$axios
			.get(`/transport-units`, { params: { limit: 250 } })
			.then((res) => {
				this.transportUnits = res.data.rows;
				if (this.user.currentTransportUnit) {
					this.transportUnits.forEach((unit, index) => {
						if (unit.id === this.user.currentTransportUnit.id) {
							this.selected = index;
                            this.activeBackBtn();
						}
					});
				}
				this.hideProgress();
			});
		// =>
		this.disabledNavigation();
	},
};
</script>

<style scoped>
.select-unit-container {
	min-height: 100vh;
	background: #fafafa;
	padding-bottom: 80px;
}

.page-header {
	background: #fff;
	padding: 20px 16px 16px;
	border-bottom: 1px solid #eee;
}

.page-title {
	font-size: 20px;
	font-weight: 600;
	color: #1a1a1a;
	margin: 0 0 4px;
}

.page-subtitle {
	font-size: 13px;
	color: #888;
	margin: 0;
}

.units-list {
	padding: 12px;
}

.unit-card {
	display: flex;
	align-items: center;
	gap: 14px;
	background: #fff;
	border-radius: 10px;
	padding: 14px;
	margin-bottom: 8px;
	cursor: pointer;
	transition: all 0.15s ease;
	border: 2px solid transparent;
}

.unit-card:active {
	transform: scale(0.98);
	background: #fafafa;
}

.unit-selected {
	border-color: #6200ea;
	background: #f8f5ff;
}

.unit-icon {
	width: 44px;
	height: 44px;
	border-radius: 10px;
	background: #f5f5f5;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.unit-selected .unit-icon {
	background: #ede7f6;
}

.unit-info {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.unit-name {
	font-size: 15px;
	font-weight: 600;
	color: #1a1a1a;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.unit-model {
	font-size: 13px;
	color: #666;
}

.unit-plate {
	font-size: 12px;
	color: #999;
	font-weight: 500;
}

.unit-check {
	flex-shrink: 0;
}

.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 20px;
	text-align: center;
}

.empty-state p {
	margin-top: 12px;
	font-size: 14px;
	color: #999;
}

.action-container {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 12px 16px;
	background: #fff;
	border-top: 1px solid #eee;
}

.save-btn {
	width: 100%;
	padding: 14px;
	border: none;
	border-radius: 10px;
	background: #6200ea;
	color: #fff;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
}

.save-btn:active {
	transform: scale(0.98);
	background: #5000d0;
}

.btn-disabled {
	background: #ccc;
	cursor: not-allowed;
}

.btn-disabled:active {
	transform: none;
	background: #ccc;
}
</style>
